<template>
    <div>
        <input
                v-model="filterArticlesObj.filter_text"
                @keyup.enter="goToFilteredArticlePage"
                type="text"
                class="search_rubric_value form-control css_StyleInput5 css_StyleOpacity css_vertical_center"
                placeholder="Введите текст"
        />
        <ul
                :style="{'display': filterArticlesObj.filter_text ? 'block' : 'none'}"
                class="dropdown-menu m-t-16 mn-w-mn-ct-imt"
        >
            <router-link
                    v-for="filterArticleObj in filterArticlesObj.filteredArticles"
                    :key="filterArticleObj.id"
                    :to="`article?r=${filterArticleObj.rubric_id}&a=${filterArticleObj.id}`"
                    custom v-slot="{ navigate }"
            >
                <li
                        @click="navigate"
                        :title="filterArticleObj.title"
                        :key="$route.path"
                ><a
                        @click="afterFilterRoute"
                        class="filter_article dropdown-item css_styleColor2 style_cursor"
                >{{filterArticleObj.title}}</a></li>
            </router-link>
            <li
                    @click="goToFilteredArticlePage"
                    v-if="filterArticlesObj.hasFilteredArticles"
                    class="style_cursor"
            ><span class="dropdown-item css_styleColor1">{{LS("Посмотреть все результаты")}}</span></li>
            <li
                    v-if="!filterArticlesObj.hasFilteredArticles"
            ><span class="dropdown-item css_styleColor1">{{LS("Не найдено")}}</span></li>
        </ul>
        <div class="box_search_rubric_button w-mx-ct">
            <button
                    @click="goToFilteredArticlePage"
                    class="btn btn-warning search_rubric_button css_vertical_center style_cursor"
            ><img src="../../assets/icons/search-solid-white.svg" width="16"></button>
        </div>
    </div>
</template>

<script>
import { reactive, computed } from 'vue'
import { storeToRefs } from 'pinia'
import {useRubricArticleStore} from "../../stores/store";
import {getFilteredArticles} from "../services/util";
import {LS} from "@/shared/services/translate";

export default {
    emits: [
        "goToFilteredArticlePage"
    ],
    setup(props, { emit }) {
        //console.log('FilterArticle');
        const rubricArticleStore = useRubricArticleStore();
        const { rubrics, articles } = storeToRefs(rubricArticleStore);

        const filterArticlesObj = reactive({
            filter_text: '',
            filteredArticles: [],
            hasFilteredArticles: false,
        });

        const afterFilterRoute = () => {
            filterArticlesObj.filter_text = '';
        }

        const goToFilteredArticlePage = () => {
            emit("goToFilteredArticlePage", filterArticlesObj.filter_text)
            afterFilterRoute()
        }

        filterArticlesObj.filteredArticles = computed(() => {
            return getFilteredArticles(rubrics.value, articles.value, filterArticlesObj.filter_text, 3);
        });

        filterArticlesObj.hasFilteredArticles = computed(() => {
            return !!Object.keys(filterArticlesObj.filteredArticles).length;
        });

        return {
            filterArticlesObj,
            afterFilterRoute,
            goToFilteredArticlePage,
            LS
        }
    }
}
</script>

<style scoped>

</style>